import { Component, OnInit, EventEmitter, Input, Output, OnChanges, SimpleChanges, forwardRef, Inject } from "@angular/core";
// import { Component, OnInit } from '@angular/core';
import { Utilities } from "../../../helpers/utilities";
import {
  HttpClient,
  HttpEventType,
  HttpErrorResponse
} from "@angular/common/http";
import { map, catchError } from "rxjs/operators";
import { of, throwError } from "rxjs";
import { StaticData } from 'src/app/helpers/static-data';


const maxFileSizeMB = 10;
const bufferChunkSize = maxFileSizeMB * (1024 * 1024);
// La constante base ya no se usa - ahora es dinámica
const batchSize = 30;
const numberFailedChunkRetries = 10;

interface FileObject {
  file: any,
  status: 'UPLOADED' | 'FAILED' | 'PENDING',
  filePartName?: string
}

interface SharePointUploadState {
  uploadUrl: string | null;
  accumulatedBytes: number;
}
@Component({
  selector: 'app-file-uploader-chunk',
  templateUrl: './file-uploader-chunk.component.html',
  styleUrls: ['./file-uploader-chunk.component.css']
})
export class FileUploaderChunkComponent implements OnInit {
  progress: number;
  progressVisual: boolean = false;
  public processDocumentChunk: EventEmitter<any> = new EventEmitter<any>();
  // Solo lo usa una llamada suelta. Cada uploadFileSharePoint crea el suyo:
  // si varios archivos corren a la vez, no pueden compartir la uploadUrl ni el offset.
  private sharedSession: SharePointUploadState = { uploadUrl: null, accumulatedBytes: 0 };

  constructor(private http: HttpClient, public utility: Utilities) { }

  ngOnInit() {
  }

  /**
   * Calcula el tamaño óptimo de chunk basándose en el tamaño del archivo
   * Archivos más grandes usan chunks más grandes para reducir llamadas HTTP
   * Microsoft Graph API permite hasta 60 MB por chunk
   */
  calculateOptimalChunkSize(fileSizeBytes: number, isSharePoint: boolean): number {
    if (!isSharePoint) {
      // Para otros servicios, usar tamaño fijo
      return bufferChunkSize;
    }

    // Para SharePoint Online - optimizar basándose en tamaño del archivo
    const fileSizeMB = fileSizeBytes / (1024 * 1024);

    if (fileSizeMB < 50) {
      // Archivos pequeños-medianos (< 50 MB): 10 MB chunks
      return 10 * 1024 * 1024;
    } else if (fileSizeMB < 200) {
      // Archivos medianos-grandes (50-200 MB): 20 MB chunks
      return 20 * 1024 * 1024;
    } else if (fileSizeMB < 500) {
      // Archivos grandes (200-500 MB): 40 MB chunks
      return 40 * 1024 * 1024;
    } else {
      // Archivos muy grandes (> 500 MB): 60 MB chunks (máximo permitido)
      return 50 * 1024 * 1024;
    }
  }

  // uploadFileChunk(Chunk, FileName, progressUpload: number) {

  //   const formData = new FormData();
  //   formData.append('file', Chunk, FileName);

  //   this.http
  //     .post(StaticData.UrlServer + '/api/fileuploadlarge/UploadChunk/', formData, {
  //       reportProgress: true,
  //       observe: "events"
  //     })
  //     .pipe(
  //       map((event: any) => {
  //         if (event.type == HttpEventType.UploadProgress) {
  //           if (this.progress <= progressUpload) {
  //             this.progress = progressUpload;
  //           }
  //           if (progressUpload === 100) {
  //             //this.progressVisual = false;
  //             console.log("Julian Higuera M");
  //           }
  //         } else if (event.type == HttpEventType.Response) {

  //         }
  //       }),
  //       catchError((err: any) => {
  //         this.progress = null;
  //         console.log(err.message);
  //         return throwError(err.message);
  //       })
  //     )
  //     .toPromise();

  // }


  /**
   * Método para flujo tradicional (NO SharePoint Online)
   * Sube chunks usando ensamblado local - compatible con bases de datos, file systems, etc.
   * Endpoint: /api/fileuploadlarge/UploadChunkLegacy
   */
  uploadFileChunk(fileObject: FileObject, position?: any, partTotal?: any, lastPart?: boolean, target?: any) {
    const formData = new FormData();
    const _lastPart = lastPart ? lastPart : false;
    formData.append('file', fileObject.file, fileObject.filePartName);

    return this.http
      .post(StaticData.UrlServer + '/api/fileuploadlarge/UploadChunkLegacy/', formData, {
        reportProgress: true,
        observe: "events"
      })
      .pipe(
        map(_ => {
          if (_.type == HttpEventType.UploadProgress && !_lastPart) {
            if (position && partTotal) {
              let progressUpload = Number(((position / partTotal) * 100).toFixed(2));
              let positionlast = partTotal - position;
              if (positionlast <= 0)
                progressUpload = 99.9;
              this.processDocumentChunk.emit({ progressUpload: progressUpload, lastPart: _lastPart, target, finaly: false });
            }
          }
          else if (_.type == HttpEventType.Response && lastPart && _.body == "finally") {
            let progressUpload = 100;
            this.processDocumentChunk.emit({ progressUpload: progressUpload, lastPart: _lastPart, target, finally: true });
          }
          else if (_.type == HttpEventType.Response && lastPart && _.body == "true") {
            fileObject.status = "FAILED";
            let progressUpload = 99.99;
            this.processDocumentChunk.emit({ progressUpload: progressUpload, lastPart: _lastPart, target, finally: true });
            this.utility.VerModalError("El archivo " + target.name + " presenta error al cargar sus partes, por favor intente nuevamente");
          }
          fileObject.status = "UPLOADED";
        }),
        catchError(_ => {
          fileObject.status = "FAILED";
          return of();
        })
      )
      .toPromise();

  }

  // 🔷 Nuevo método para SharePoint Online - optimizado con Upload Session API y 4MB chunks
  uploadFileChunkSharePoint(fileObject: FileObject, position?: any, partTotal?: any, lastPart? : boolean, target?: any, session?: SharePointUploadState) {
    //debugger;
    const formData = new FormData();
    const _lastPart = lastPart? lastPart : false
    formData.append('file', fileObject.file, fileObject.filePartName);

    // Enviar tamaño total del archivo original (CRÍTICO para SharePoint Upload Session)
    if (target && target.size) {
      formData.append('totalFileSize', target.size.toString());
    }

    if (target && target.name) {
      formData.append('originalFileName', target.name);
    }

    // 🔥 ENVIAR RANGESTART ACUMULADO REAL (bytes subidos hasta ahora)
    // Esto es CRUCIAL para manejar chunks de tamaño variable (el último chunk suele ser más pequeño)
    // Ejemplo: Archivo 1GB con chunks de 60MB
    //   Chunk 1: rangeStart=0 (0 bytes subidos)
    //   Chunk 2: rangeStart=62914560 (60MB subidos)
    //   Chunk 18: rangeStart=1010827520 (17*60MB subidos)
    // IMPORTANTE: El valor actual de accumulatedBytes es el rangeStart de ESTE chunk
    const state = session || this.sharedSession;
    const currentRangeStart = state.accumulatedBytes;
    formData.append('rangeStart', currentRangeStart.toString());

    // 🔥 ACUMULAR BYTES AHORA (antes de enviar) para que el SIGUIENTE chunk tenga el offset correcto
    state.accumulatedBytes += fileObject.file.size;

    // Si ya tenemos uploadUrl (chunks 2-N), enviarlo al backend
    if (state.uploadUrl) {
      formData.append('uploadUrl', state.uploadUrl);
    }

    // Enviar información de tipo de ubicación y configuración de SharePoint si está disponible
    if (StaticData.GeneralConfig &&
        StaticData.GeneralConfig.ConfigExpediente &&
        StaticData.GeneralConfig.ConfigExpediente.ConfigDocumento &&
        StaticData.GeneralConfig.ConfigExpediente.ConfigDocumento.ConfigTipoUbicacionArchivo) {

      const config = StaticData.GeneralConfig.ConfigExpediente.ConfigDocumento.ConfigTipoUbicacionArchivo;

      if (config.TipoUbicacionArchivo) {
        formData.append('tipoUbicacion', config.TipoUbicacionArchivo.toString());

        // Si es SharePoint Online, enviar configuración completa
        if (config.TipoUbicacionArchivo === "SharePointGraphAPI") {
          formData.append('spConfig', JSON.stringify(config));
        }
      }
    }
    return this.http
      .post(StaticData.UrlServer + '/api/fileuploadlarge/UploadChunk/', formData, {
        reportProgress: true,
        observe: "events"
      })
      .pipe(
        map(_ => {

          if(_.type == HttpEventType.UploadProgress && !_lastPart)
          {
            if (position && partTotal) {
              let progressUpload = Number(((position / partTotal) * 100).toFixed(2))
              let positionlast = partTotal - position;
              if (positionlast <= 0)
                progressUpload = 99.9
              this.processDocumentChunk.emit({ progressUpload: progressUpload , lastPart : _lastPart, target, finally : false});
            }
          }
          else if (_.type == HttpEventType.Response && lastPart && _.body ==  "finally")
          {
            let progressUpload = 100
            this.processDocumentChunk.emit({ progressUpload: progressUpload , lastPart : _lastPart, target, finally: true});
          }
          else if (_.type == HttpEventType.Response && lastPart)
          {
            // Último chunk - puede ser JSON con información completa o "finally" legacy
            try {
              if (_.body === 'error' || _.body === 'false') {
                console.error('❌ [FRONTEND-SharePoint] Último chunk falló con respuesta:', _.body);
                fileObject.status = "FAILED";
                this.utility.VerModalError("El archivo " + target.name + " presenta error al finalizar, por favor intente nuevamente");
                return;
              }

              // Intentar parsear como JSON
              const bodyObj = typeof _.body === 'string' ? JSON.parse(_.body) : _.body;

              if (bodyObj && bodyObj.status === 'finally') {

                let progressUpload = 100;
                this.processDocumentChunk.emit({
                  progressUpload: progressUpload,
                  lastPart: _lastPart,
                  target,
                  finally: true,
                  fileInfo: {
                    fileName: bodyObj.fileName,
                    url: bodyObj.url,
                    size: bodyObj.size,
                    extension: bodyObj.extension,
                    totalPages: bodyObj.totalPages || 0
                  }
                });
              } else if (
                bodyObj &&
                bodyObj.status === 'session_created' &&
                target &&
                fileObject.file &&
                fileObject.file.size === target.size
              ) {
                // Una sola parte cubre el archivo entero. Graph cierra la sesión
                // en ese PUT (el rango llega al último byte) y el API responde
                // session_created, porque reserva "finally" para un chunk posterior.
                // La pantalla completa igual: el archivo ya quedó en TempDocs.
                this.processDocumentChunk.emit({
                  progressUpload: 100,
                  lastPart: _lastPart,
                  target,
                  finally: true
                });
              } else if (_.body === 'finally') {
                // Formato legacy
                let progressUpload = 100;
                this.processDocumentChunk.emit({ progressUpload: progressUpload, lastPart: _lastPart, target, finally: true });
              }
            } catch (error) {
              // Si no es JSON, asumirlo como string "finally"
              if (_.body === 'finally') {
                let progressUpload = 100;
                this.processDocumentChunk.emit({ progressUpload: progressUpload, lastPart: _lastPart, target, finally: true });
              } else {
                console.error('❌ [FRONTEND-SharePoint] Error al procesar respuesta del último chunk:', error, _.body);
                fileObject.status = "FAILED";
              }
            }
          }
          else if (_.type == HttpEventType.Response && !lastPart && !state.uploadUrl)
          {
            // Primer chunk - capturar uploadUrl de la respuesta
            try {
              // Si el body es "error" o "false", no intentar parsear como JSON
              if (_.body === 'error' || _.body === 'false') {
                console.error('❌ [FRONTEND-SharePoint] Chunk 1 falló con respuesta:', _.body);
                fileObject.status = "FAILED";
                return;
              }

              const bodyObj = typeof _.body === 'string' ? JSON.parse(_.body) : _.body;
              if (bodyObj && bodyObj.uploadUrl) {
                state.uploadUrl = bodyObj.uploadUrl;
              } else if (bodyObj && bodyObj.status === 'session_created') {
                console.warn('⚠️ [FRONTEND-SharePoint] Respuesta del chunk 1 sin uploadUrl:', bodyObj);
              }
            } catch (error) {
              console.error('❌ [FRONTEND-SharePoint] Error al parsear respuesta del chunk 1:', error, _.body);
              fileObject.status = "FAILED";
            }
          }
          else if(_.type == HttpEventType.Response && lastPart && _.body ==  "error")
          {
            console.error('❌ [FRONTEND-SharePoint] Response recibido: ERROR - Error en upload de partes', {
              body: _.body,
              lastPart: lastPart,
              fileName: target.name
            });
            //debugger;
            fileObject.status = "FAILED";
            let progressUpload = 99.99
            this.processDocumentChunk.emit({ progressUpload: progressUpload , lastPart : _lastPart, target, finally: true});
            this.utility.VerModalError("El archivo " + target.name+ " presenta error al cargar sus partes, por favor intente nuevamente");
          }
          else if(_.type == HttpEventType.Response && !lastPart)
          {
            // Chunk intermedio - validar respuesta antes de procesar
            if (_.body === 'error' || _.body === 'false') {
              console.error('❌ [FRONTEND-SharePoint] Chunk intermedio falló con respuesta:', _.body);
              fileObject.status = "FAILED";
              return;
            }

            // Chunk intermedio - éxito
            try {
              var bodyObj = typeof _.body === 'string' ? JSON.parse(_.body) : _.body;
              var chunkInfo = 'N/A';
              if (bodyObj && bodyObj['chunkIndex'] && bodyObj['totalChunks']) {
                chunkInfo = bodyObj['chunkIndex'] + '/' + bodyObj['totalChunks'];
              }
            } catch (error) {
              console.error('❌ [FRONTEND-SharePoint] Error al parsear respuesta de chunk intermedio:', error, _.body);
              fileObject.status = "FAILED";
            }
          }
          else if(_.type == HttpEventType.Response)
          {
            // Validar si es error antes de procesar
            if (_.body === 'error' || _.body === 'false') {
              console.error('❌ [FRONTEND-SharePoint] Chunk falló con respuesta:', _.body);
              fileObject.status = "FAILED";
              return;
            }

            console.log('⚠️ [FRONTEND-SharePoint] Response recibido pero no coincide con condiciones esperadas:', {
              body: _['body'],
              lastPart: lastPart,
              bodyType: typeof _['body']
            });
          }

          fileObject.status = "UPLOADED";
        }),
        catchError(error => {
          console.error('💥 [FRONTEND-SharePoint] ERROR en catchError:', {
            error: error,
            errorMessage: error && error.message,
            errorStatus: error && error.status,
            errorStatusText: error && error.statusText,
            fileName: target && target.name,
            position: position,
            partTotal: partTotal
          });
          fileObject.status = "FAILED";
          return of();
        })
      )
      .toPromise();

  }

  // uploadFile(TargetFile) {

  //   // create array to store the buffer chunks
  //   const fileChunk = [];
  //   // the file object itself that we will work with
  //   // set up other initial vars
  //   const maxFileSizeMB = 3;
  //   const bufferChunkSize = maxFileSizeMB * (1024 * 1024);
  //   // let ReadBuffer_Size = 1024;
  //   let fileStreamPos = 0;
  //   // set the initial chunk length
  //   let endPos = bufferChunkSize;
  //   const size = TargetFile.size;

  //   // add to the FileChunk array until we get to the end of the file
  //   while (fileStreamPos < size) {
  //     // "slice" the file from the starting position/offset, to  the required length
  //     fileChunk.push(TargetFile.slice(fileStreamPos, endPos));
  //     fileStreamPos = endPos; // jump by the amount read
  //     endPos = fileStreamPos + bufferChunkSize; // set next chunk length
  //   }
  //   // get total number of "files" we will be sending
  //   const totalParts = fileChunk.length;
  //   let partCount = 0;
  //   this.progress = 1;
  //   this.progressVisual = true;

  //   for (let valueChunk of fileChunk) {
  //     partCount++;
  //     const filePartName = TargetFile.name + '.part_' + partCount + '.' + totalParts;
  //     // send the file
  //     this.uploadFileChunk(valueChunk, filePartName, Number(((partCount / totalParts) * 100).toFixed(2)));

  //     if (partCount === totalParts) {
  //       this.progress = null;
  //     }
  //   }
  // }
  /**
   * Método principal que decide qué flujo usar según la configuración
   */
  async uploadFile(target: any) {
    // Detectar si es SharePoint Online
    let isSharePoint = false;
    if (StaticData.GeneralConfig &&
        StaticData.GeneralConfig.ConfigExpediente &&
        StaticData.GeneralConfig.ConfigExpediente.ConfigDocumento &&
        StaticData.GeneralConfig.ConfigExpediente.ConfigDocumento.ConfigTipoUbicacionArchivo &&
        StaticData.GeneralConfig.ConfigExpediente.ConfigDocumento.ConfigTipoUbicacionArchivo.TipoUbicacionArchivo === 'SharePointGraphAPI') {
      isSharePoint = true;
    }

    if (isSharePoint) {
      // SharePoint Online: usa lógica compleja con Upload Session API
      await this.uploadFileSharePoint(target);
    } else {
      // Tradicional: usa lógica simple con ensamblado local
      await this.uploadFileLegacy(target);
    }
  }

  /**
   * Flujo tradicional (NO SharePoint) - Ensamblado local de chunks
   * Lógica simple: batch upload + reintentos + último chunk
   */
  async uploadFileLegacy(target: any) {
    const fileChunk = this.splitFile(target);
    const lastPart = fileChunk.pop();
    this.progress = 1;
    this.progressVisual = true;

    await this.uploadinBatch(fileChunk, target);

    const filesFailed = fileChunk.filter(file => file.status === "FAILED");

    if (filesFailed.length > 0)
      await this.proccessFailedChunk(filesFailed, numberFailedChunkRetries);

    if (lastPart) {
      await this.uploadFileChunk(lastPart, null, null, true, target);
    }

    console.log("valueChunk", filesFailed, fileChunk, lastPart, fileChunk.filter(file => file.status === "FAILED"));
  }

  /**
   * Flujo SharePoint Online - Upload Session API con uploadUrl
   * Lógica compleja: chunk 1 obtiene uploadUrl → chunks 2-N usan uploadUrl → chunk final
   */
  async uploadFileSharePoint(target: any) {
    // Una sesión por archivo. El componente es uno solo y el selector dispara
    // varias cargas sin esperar; si compartieran estos dos campos, el siguiente
    // archivo borra la uploadUrl y el offset del que todavía está subiendo.
    const session: SharePointUploadState = { uploadUrl: null, accumulatedBytes: 0 };

    // Cálculo dinámico: tamaño óptimo de chunk para SharePoint (10MB-60MB)
    const chunkSizeForSplit = this.calculateOptimalChunkSize(target.size, true);
    const fileChunk = this.splitFile(target, chunkSizeForSplit);

    this.progress = 1;
    this.progressVisual = true;

    // pop()+shift() y "length + 2" suponen al menos dos partes.
    // Entre 4 MiB y 10 MiB el corte de 10 MiB deja una sola: shift() la pierde
    // y el total queda en 2. Esa parte se envía una vez, tal como viene.
    if (fileChunk.length === 1) {
      const onlyChunk = fileChunk[0];
      await this.uploadFileChunkSharePoint(onlyChunk, 1, 1, true, target, session);
      if (onlyChunk.status === "FAILED") {
        this.utility.VerModalError(`Error al subir el archivo ${target.name}.`);
      }
      return;
    }

    const lastPart = fileChunk.pop();
    const firstChunk = fileChunk.shift();
    const totalChunks = fileChunk.length + 2;

    // 1️⃣ CHUNK 1: Crear sesión y obtener uploadUrl
    if (firstChunk) {
      await this.uploadFileChunkSharePoint(firstChunk, 1, totalChunks, false, target, session);

      if (!session.uploadUrl) {
        console.error('❌ [FRONTEND-SharePoint] ERROR: Chunk 1 completado pero NO se capturó uploadUrl');
        this.utility.VerModalError(`Error al iniciar la sesión de carga para ${target.name}`);
        return;
      }
    }

    // 2️⃣ CHUNKS 2-(N-1): Subir secuencialmente usando uploadUrl
    if (fileChunk.length > 0) {
      for (let i = 0; i < fileChunk.length; i++) {
        const chunkIndex = i + 2;

        await this.uploadFileChunkSharePoint(fileChunk[i], chunkIndex, totalChunks, false, target, session);

        if (fileChunk[i].status === "FAILED") {
          console.error(`❌ [FRONTEND-SharePoint] Chunk ${chunkIndex} falló. Reintentando...`);

          let retryCount = 0;
          while (fileChunk[i].status === "FAILED" && retryCount < numberFailedChunkRetries) {
            retryCount++;
            await this.uploadFileChunkSharePoint(fileChunk[i], chunkIndex, totalChunks, false, target, session);
          }

          if (fileChunk[i].status === "FAILED") {
            console.error(`❌ [FRONTEND-SharePoint] Chunk ${chunkIndex} falló después de ${numberFailedChunkRetries} reintentos`);
            this.utility.VerModalError(`Error al subir el archivo ${target.name}. El chunk ${chunkIndex} falló.`);
            return;
          }
        }
      }
    }

    // 3️⃣ ÚLTIMO CHUNK: Finalizar sesión
    if (lastPart) {
      await this.uploadFileChunkSharePoint(lastPart, totalChunks, totalChunks, true, target, session);

      if (lastPart.status === "FAILED") {
        console.error('❌ [FRONTEND-SharePoint] Último chunk falló');
        this.utility.VerModalError(`Error al finalizar la subida del archivo ${target.name}.`);
      }
    }
  }
  splitFile(targetFile: any, chunkSize?: number): FileObject[] {
    let fileChunk: FileObject[] = [];
    let fileStreamPos = 0;
    // 🔷 Usar tamaño personalizado si se proporciona (para SharePoint: 4MB), sino usar default (10MB)
    const effectiveChunkSize = chunkSize ? chunkSize : bufferChunkSize;
    let endPos = effectiveChunkSize;
    let partCount = 0;
    const size = targetFile.size;


    while (fileStreamPos < size) {
      fileChunk = [...fileChunk, {
        file: targetFile.slice(fileStreamPos, endPos),
        status: "PENDING"
      }]
      fileStreamPos = endPos;
      endPos = fileStreamPos + effectiveChunkSize;
    }

    for (let valueChunk of fileChunk) {
      partCount++;
      valueChunk.filePartName = StaticData.Usuario.IdUsuario + targetFile.name + '.part_' + partCount + '.' + fileChunk.length;
    }


    return fileChunk;
  }

  async uploadinBatch(fileChunk: FileObject[], target: any) {
    let position = 0;
    let results: any[] = [];
    while (position < fileChunk.length) {
      const itemsForBatch = fileChunk.slice(position, position + batchSize);
      results = [...results,
      ...await Promise.all(
        itemsForBatch.map(valueChunk =>
          this.uploadFileChunk(valueChunk, position + batchSize, fileChunk.length,false, target)
        )
      )
      ];
      position += batchSize;
    }
  }

  async proccessFailedChunk(fileChunkFailed: FileObject[], retryNumber: number) {
    console.log("TRIED", retryNumber, fileChunkFailed)
    if (retryNumber > 0) {
      await this.uploadinBatch(fileChunkFailed, null);

      const filesFailed = fileChunkFailed.filter(file => file.status === "FAILED")

      console.log("FILES FAILED AFTER FIRST TRIED", filesFailed)
      if (filesFailed.length > 0) {
        await this.proccessFailedChunk(filesFailed, numberFailedChunkRetries - 1)
      }

    }
  }
}
